import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { FilterBar } from './FilterBar'
import { Sidebar } from './Sidebar'
import { Footer } from './Footer'
import { PageOverlay } from './PageOverlay'
import { PdfViewerModal } from './PdfViewerModal'
import { ProductTour } from '@/components/tour/ProductTour'
import { UnsavedNotesDialog } from '@/components/content/UnsavedNotesDialog'
import { PwaUpdatePrompt } from '@/components/PwaUpdatePrompt'
import { useAppStore } from '@/store/appStore'
import { useHashOverlay } from '@/hooks/useHashOverlay'
import { usePageTitle } from '@/hooks/usePageTitle'
import { useGlobalContentKeyScroll } from '@/hooks/useContentScrollArea'

export function AppShell() {
  useHashOverlay()
  usePageTitle()
  useGlobalContentKeyScroll()
  const { pdfViewer, setPdfViewer } = useAppStore()

  return (
    <div className="app-shell">
      {/* Header section (sticky at top) */}
      <div className="sticky-top">
        <Header />
        <PwaUpdatePrompt />
        <FilterBar />
      </div>

      {/* Main content section (flexbox: sidebar left, content right) */}
      <div className="app-body">
        {/* Sidebar tree view on the left */}
        <Sidebar />

        {/* Main content area on the right */}
        <main className="main-content main-content--flex" id="main-content" tabIndex={-1}>
          {/* Outlet fills remaining height; each page controls its own scrolling */}
          <div className="main-outlet" tabIndex={0}>
            <Outlet />
          </div>
          <Footer />
        </main>
      </div>

      <PageOverlay />
      <ProductTour />

      {/* Any navigation or filter change routed through requestGuardedAction surfaces here. */}
      <UnsavedNotesDialog />

      {/* Global PDF viewer triggered from RichContent */}
      {pdfViewer && (
        <PdfViewerModal
          open={true}
          systemFileName={pdfViewer.systemFileName}
          title={pdfViewer.title}
          onClose={() => setPdfViewer(null)}
        />
      )}
    </div>
  )
}
